import { toast } from 'react-hot-toast';

export const showToast = (message, type = 'default') => {
    toast.dismiss();

    switch (type) {
        case 'success':
            toast.success(message, {
                style: {
                    fontSize: "20px",
                    border: "1px solid #000000",
                    padding: "16px",
                },
            });
            break;
        case 'error':
            toast.error(message, {
                style: {
                    fontSize: "20px",
                    border: "1px solid #000000",
                    padding: "16px",
                },
            });
            break;
        case 'loading':
            toast.loading(message, {
                style: {
                    fontSize: "20px",
                    border: "1px solid #000000",
                    padding: "16px",
                },
            });
            break;
        default:
            toast(message, {
                style: {
                    fontSize: "20px",
                    border: "1px solid #000000",
                    padding: "16px",
                },
            });
            break;
    }
};